import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 560);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-4 md:right-6 z-40 w-11 h-11 flex items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-800 transition-opacity duration-300 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 cursor-pointer ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}